export default {
  'upload-files': 'Upload files',
  'assign-products': 'Assign inspector',
  'edit-products': 'Edit'
};
